import Vue from 'vue'
import Router from 'vue-router'
import buyVip from '@/components/buyVip'
import homeVue from '../components/home.vue'

Vue.use(Router)

export default new Router({
	base: '/cuntu/',
	mode: 'history',
	routes: [{
		path: '/buy',
		name: 'buyVip',
		component: buyVip,
		meta: {
			title: "购买会员"
		}
	}, {
		path: '/',
		name: 'home',
		component: homeVue,
		meta: {
			title: "首页"
		}
	}]
})



// WEBPACK FOOTER //
// ./src/router/index.js
